export default __webpack_public_path__ + "assets/boris-berenstein-component.385d5271.svg";